import React, { Component } from 'react';
import styled from 'styled-components';
import Header from '../../shared/Header';
import SignupForm from './SignupForm';
import { withRouter } from 'react-router-dom';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-color: #2a425e;
  display: block;
  justify-content: center;
`;

class Signup extends Component {
  render() {
    return (
      <Wrapper>
        <Header type="login" style={{ position: 'relative' }} />
        <SignupForm
          style={{ position: 'relative' }}
          checkoutlink={
            this.props.location.state && this.props.location.state.link
          }
        />
      </Wrapper>
    );
  }
}

export default withRouter(Signup);



// WEBPACK FOOTER //
// ./src/components/screens/Signup/Signup.jsx